import { AfterContentInit, Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OneQuickSelectionDatepickerService } from '@one/angular-kit/form';
import { MatRadioChange } from '@angular/material/radio';
import { CreateReminderDialogService } from '../../create-reminder-dialog.service';

@Component({
  selector: 'dl-reminder-date-picker',
  templateUrl: './reminder-date-picker.component.html',
  styleUrls: ['./reminder-date-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReminderDatePickerComponent implements AfterContentInit {
  public feedbackDate: Date = this.createReminderDialogService.dueDateValue;
  public date: FormControl = new FormControl('');
  public dateShortcut: FormControl = new FormControl('');
  public dueDateDiff: number = this.createReminderDialogService.calculateDateDiff();
  public constructor(private readonly quickSelectionService: OneQuickSelectionDatepickerService, private createReminderDialogService: CreateReminderDialogService) {}

  public setDateFilter(value: number) {
    const reminderDate = new Date(this.feedbackDate.getTime() - value * 24 * 60 * 60 * 1000); // new Date();
    // reminderDate.setDate(nextDate.getDate() - value);  // setDate method was causing issue, it was updating the feedbackDueDate
    this.date.setValue(reminderDate);
    this.quickSelectionService.setDate(this.date);
  }

  public ngAfterContentInit() {
    this.date = this.quickSelectionService.getDate();
    this.dateShortcut = this.quickSelectionService.getDateShortcut();
  }

  public radioChange($event: MatRadioChange) {
    this.setDateFilter(parseInt($event.value, 10));
    this.quickSelectionService.closeCalendar(true);
  }
}
